import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Button from "@irati/ui/src/Button"
import {FormattedMessage} from "@irati/utils/lang"
import History from "@irati/utils/history"

import {VIEW_PEOPLE} from "../../../routes/routeConfig"

class BackLink extends PureComponent {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  handleClick = () => {
    History.push(VIEW_PEOPLE, this.context.apps.ADMIN)
  }

  render() {
    return (
      <Button tertiary onClick={this.handleClick} marginBottom={2}>
        <Icon icon={IconTypes.chevronLeft} marginRight />
        <FormattedMessage id="admin.user.back.label" />
      </Button>
    )
  }
}

export default BackLink
